import { apiClient } from "@/services/api";

const state = () => ({
    pracas: null,
})

const getters = {
    getterPracas: state => {
        return state.pracas
    }
}

const actions = {
    async getPracas({ commit }) {
        try {
            const { data } = await apiClient.get(
                `/listarPracas`
            );
            commit('setPracas', data.pracas);
        } catch (error) {
            return error;
        }
    }
}

const mutations = {
    setPracas(state, payload) {
        state.pracas = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};